import React from 'react';
import { Card as SCard } from 'semantic-ui-react';
import { DateRange } from '../common/DateRange';
import { useHistory } from 'react-router-dom';

const matchLabels = {
  profile_first_name: 'Matched: First Name',
  profile_last_name: 'Matched: Last Name',
  composer_first_name: 'Matched: Composer First Name',
  composer_last_name: 'Matched: Composer Last Name',
  song_title: 'Matched: Song Title',
  song_cycle_title: 'Matched: Song Cycle Title',
  song_text: 'Matched: Song Text',
};

const matchColors = {
  profile_first_name: 'blue',
  profile_last_name: 'teal',
  composer_first_name: 'purple',
  composer_last_name: 'violet',
  song_title: 'green',
  song_cycle_title: 'orange',
  song_text: 'red',
};

export const CardTextAuthor = ({ data, matchedQueries = [] }) => {
  const history = useHistory();

  const handleClick = async () => {
    try {
      const profileId = data.profile.id;

      // Fetch composer matching this profile

      const res = await fetch(`/go/api/v1/composers/search?q=profile.id:${profileId}`);

      const json = await res.json();

      if (!json.hits?.hits?.length) return;

      const composerId = json.hits.hits[0]._source.id;

      if (composerId) {
	      window.open(`/composers/${composerId}`, '_blank', 'noopener,noreferrer');
      }
    } catch (err) {
      console.error("Error redirecting to composer:", err);
    }
  };

  return (
    <SCard
      fluid
      color="blue"
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <SCard.Content>
        <SCard.Header>
          {data.profile.first_name} {data.profile.last_name}
        </SCard.Header>

        {data.profile.birth_date && data.profile.death_date && (
          <SCard.Meta>
            <DateRange
              start={data.profile.birth_date}
              end={data.profile.death_date}
            />
          </SCard.Meta>
        )}
      </SCard.Content>

      {matchedQueries.length > 0 && (
        <SCard.Content extra>
          <div className="center aligned">
            {matchedQueries.map((match) => (
              <span
                key={match}
                className={`ui ${matchColors[match] || 'grey'} label`}
              >
                {matchLabels[match] || `Matched: ${match}`}
              </span>
            ))}
          </div>
        </SCard.Content>
      )}
    </SCard>
  );
};

